import { ISwAppProcessorBalancesApi } from "../../interfaces-and-types";

type TTransactionsUrls = {
  [key in keyof ISwAppProcessorBalancesApi]: string;
};

const rootTopUpsUrl = "/processor-balance-services";

export const processorBalancesUrls: TTransactionsUrls = {
  // getProcessorBalanceByGatewayCode: `${rootTopUpsUrl}/fetch-processor-balance`,
  listInterProcessorBatchTransfers: `${rootTopUpsUrl}/batch`,
  getInterProcessorBatchTransferById: `${rootTopUpsUrl}/batch/{id}`,
  listInterProcessorSingleTransfers: `${rootTopUpsUrl}/list-single-transfers`,
  getInterProcessorSingleTransferById: `${rootTopUpsUrl}/single/{id}`,

  moveFunds: `${rootTopUpsUrl}/move-funds`,
  listProcessorTopUpWalletBankDetails: `${rootTopUpsUrl}/fetch-topup-wallet-details`,
};
